import api from "./api"
import { Credentials, User } from "../Interfaces"
import { AxiosError } from "axios"

class AuthService {
  private baseUrl = "/auth";

  async getAuthFromCredentials(credentials: Credentials) {
    try {
      const response = await api.post(
        `${this.baseUrl}/login`,
        credentials
      )
      await this.setToken(response.data.accessToken, response.data.user)
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
    }
  }

  // get authenticated user
  async getAthenticatedUser() {
    const response = await api.get("/authenticate")
    return response.data
  }

  async forgotPassword(email: string) {
    try {
      const response = await api.post(
        `${this.baseUrl}/forgot-password`,
        { email }
      )
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
    }
  }

  async resetPassword(token: string, password: string) {
    try {
      const response = await api.post(
        `${this.baseUrl}/reset-password`,
        { token, password }
      )
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
    }
  }

  private async setToken(token: string, user: User) {
    localStorage.setItem("token", token)
    localStorage.setItem("user", JSON.stringify(user))
  }

  logout() {
    localStorage.removeItem("token")
    localStorage.removeItem("user")
  }
}

export const authService = new AuthService()
